// Tugash arafasidagi paketlar — `GET /api/grants/expiring`.
//
// ⚠️ NEGA BU ENDPOINT KERAK BO'LDI. Panel abonent uzilgandan KEYIN
// xabar berardi ("onlayn 0", "kvota tugadi"). Bu esa kech: abonent
// allaqachon internetsiz qolgan va qo'ng'iroq qilyapti. Tugash
// arafasidagi paket esa SOTUV IMKONIYATI — operator oldindan bog'lanib
// yangi paket taklif qila oladi.
//
// Huquq: `subscriber.read`. Doira SERVER TOMONDA qo'llanadi, ya'ni
// reseller faqat o'z tarmog'idagilarni ko'radi.

import { z } from 'zod'
import { api } from '@/shared/api/client'
import { instantSchema, uuidSchema } from '@/shared/api/schemas'

/** NIMA tugayapti. Ikkalasi ham yaqin bo'lsa server `VOLUME` beradi. */
export const EXPIRY_REASONS = ['TIME', 'VOLUME'] as const
export type ExpiryReason = (typeof EXPIRY_REASONS)[number]

const expiringGrantSchema = z.object({
  grantId: uuidSchema,
  subscriberId: uuidSchema,
  login: z.string(),
  displayName: z.string().nullish(),
  planId: uuidSchema.nullish(),
  expiresAt: instantSchema.nullish(),
  quotaBytes: z.number().nullish(),
  consumedBytes: z.number(),
  remainingBytes: z.number().nullish(),
  /** 0..100. `null` — kvota yo'q, ulushni hisoblab bo'lmaydi */
  remainingPercent: z.number().nullish(),
  reason: z.string(),
})

export interface ExpiringGrant {
  grantId: string
  subscriberId: string
  login: string
  displayName: string | null
  planId: string | null
  /** `null` — muddatsiz paket */
  expiresAt: string | null
  quotaBytes: number | null
  consumedBytes: number
  /** `null` — hajm bo'yicha cheksiz */
  remainingBytes: number | null
  remainingPercent: number | null
  reason: ExpiryReason | 'UNKNOWN'
}

function toReason(raw: string): ExpiryReason | 'UNKNOWN' {
  const upper = raw.trim().toUpperCase()
  return (EXPIRY_REASONS as readonly string[]).includes(upper)
    ? (upper as ExpiryReason)
    : 'UNKNOWN'
}

export interface ExpiringQuery {
  /** Muddati shu soatlar ichida bitadiganlar */
  withinHours?: number
  /** Hajmi shu foizdan kam qolganlar */
  remainingPercent?: number
  limit?: number
}

export async function fetchExpiringGrants(query: ExpiringQuery = {}): Promise<ExpiringGrant[]> {
  const response = await api.get<unknown>('/api/grants/expiring', {
    params: {
      withinHours: query.withinHours ?? 24,
      remainingPercent: query.remainingPercent ?? 10,
      limit: query.limit ?? 20,
    },
  })
  return z
    .array(expiringGrantSchema)
    .parse(response.data)
    .map((row) => ({
      grantId: row.grantId,
      subscriberId: row.subscriberId,
      login: row.login,
      displayName: row.displayName ?? null,
      planId: row.planId ?? null,
      expiresAt: row.expiresAt ?? null,
      quotaBytes: row.quotaBytes ?? null,
      consumedBytes: row.consumedBytes,
      remainingBytes: row.remainingBytes ?? null,
      remainingPercent: row.remainingPercent ?? null,
      reason: toReason(row.reason),
    }))
}
